import React, { Component, ReactNode } from 'react';
import { ErrorWithRetry } from './common/ErrorMessage';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            maxWidth: '600px',
            margin: '100px auto',
            padding: '0 20px',
          }}
        >
          <ErrorWithRetry
            message="Aplikacja napotkała nieoczekiwany błąd. Odśwież stronę aby spróbować ponownie."
            onRetry={this.handleRetry}
          />
        </div>
      );
    }

    return this.props.children;
  }
}
